import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'
import deviceInfoProvider from 'src/utils/deviceInfoProvider'

// ArComponents
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const StyledWrapper = styled.div`
  ${ ({ mobileImageWrapperStyles }) => mobileImageWrapperStyles }
  ${ media.tablet`${ ({ tabletImageWrapperStyles }) => tabletImageWrapperStyles }` }
  ${ media.desktop`${ ({ desktopImageWrapperStyles }) => desktopImageWrapperStyles }` }
`

const StyledImage = styled(ArBaseImage)`
  ${ ({ mobileImageStyles }) => mobileImageStyles }
  ${ media.tablet`${ ({ tabletImageStyles }) => tabletImageStyles }` }
  ${ media.desktop`${ ({ desktopImageStyles }) => desktopImageStyles }` }
`

const TypeImageShape = PropTypes.shape({
  alt: PropTypes.string,
  copyright: PropTypes.string,
  url: PropTypes.string,
})

class ArHeroImageWrapper extends React.Component {
  static propTypes = {
    imageDesktop: TypeImageShape,
    imageTablet: TypeImageShape,
    imageMobile: TypeImageShape,
    image: TypeImageShape,
    mobileImageWrapperStyles: PropTypes.any,
    tabletImageWrapperStyles: PropTypes.any,
    desktopImageWrapperStyles: PropTypes.any,
    mobileImageStyles: PropTypes.any,
    tabletImageStyles: PropTypes.any,
    desktopImageStyles: PropTypes.any,

  }

  render () {
    const images = this.props.images
    const { browserImageProps, mobileImageProps, ...rest } = this.props
    return (
      <StyledWrapper {...this.props}>
        <StyledImage {...browserImageProps} {...rest} src={images.browser.url} alt={images.browser.alt} scFit={'contain'} />
        <StyledImage {...mobileImageProps} {...rest} src={images.mobile.url} alt={images.mobile.alt} scFit={'contain'} />
      </StyledWrapper>
    )
  }
}

export default deviceInfoProvider(ArHeroImageWrapper)
